import {Component, HostListener, OnInit} from '@angular/core';
import {UserSearch, UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {CommonService} from '@services/common.service';
import {CityService} from '@services/city.service';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {City} from '@models/city';
import {SaveCityComponent} from '@module/search/popup/save-city/save-city.component';
import {EVOL_DEMO_LAST_YEAR, SEARCH_PARAMS} from '@models/empty';
import {OnboardingService} from '@services/onboarding.service';
import {EditCityComponent} from '@module/search/popup/edit-city/edit-city.component';
import {DupplicateCityComponent} from '@module/search/popup/dupplicate-city/dupplicate-city.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';

@Component({
    selector: 'app-results-city',
    templateUrl: './results-city.component.html',
    styleUrls: ['./results-city.component.scss']
})
export class ResultsCityComponent implements OnInit {
    cities: City[] = [];
    cacheCities: City[] = [];
    citiesFull: City[] = [];
    loading = false;

    result = -1;
    nbAds = 0;
    params;
    currentIndex = 0;
    onboarding = false;

    currentSearch: UserSearchCity;
    userSearchs: UserSearchCity[] = [];

    constructor(
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        public commonService: CommonService,
        public cityService: CityService,
        private onboardingService: OnboardingService,
        public dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.params = {'id': ''};
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearchCity().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                this.setParams();
            });
        } else {
            this.setParams();
        }

        this.onboardingService.listen().subscribe(elem => {
            if (elem == 'search_city_start') {
                this.onboarding = true;
                if (this.cities.length > 3) {
                    this.cacheCities = this.cities;
                    this.cities = [this.cities[0], this.cities[1]];
                }
            }
            if (elem == 'search_city_end') {
                this.cities = this.cacheCities;
                this.onboarding = false;
            }
        });
    }

    setParams() {
        this.route.params.subscribe(params => {
            this.params = params;
            if (params.id !== undefined) {
                if (params.id == 'result') {
                    this.userService.getCurrentSearchCity().subscribe(params => {
                        this.currentSearch = params;
                        this.search();
                    });
                } else {
                    this.setSearch();
                }
            }
        });
    }

    setSearch() {
        if (this.params.id !== undefined && this.userSearchs.length > 0) {
            if (this.authenticationService.isAllowed('essentiel')) {
                this.userSearchs.forEach(f => {
                    if (f.id === parseInt(this.params.id, 10)) {
                        this.currentSearch = f;
                        this.search();
                    }
                });
            } else {
                this.alertService.error('Cette fonctionnalité néccessite un plan supérieur, consultez nos forfaits dans Mon comptes > Nos forfaits');
            }
        }
    }

    search() {
        this.cities = [];
        this.citiesFull = [];

        this.loading = true;
        this.trackingService.searchCity();
        this.result = -1;
        this.adService.searchCities(this.currentSearch.search_city_params).subscribe(cities => {
            if (cities == null) {
                this.alertService.error('Veuillez ajouter des filtres');
                return;
            }
            this.result = cities.length;

            if (cities.length === 0) {
                this.alertService.error('Aucun résultat');
            } else {
                this.citiesFull = cities;
                this.citiesFull.sort((a, b) => a.name < b.name ? 0 : 1);
                this.loadResult();
                if (this.onboarding === true) {
                    if (this.cities.length > 3) {
                        this.cacheCities = this.cities;
                        this.cities = [this.cities[0], this.cities[1]];
                    }
                }
            }

            this.loading = false;
        }, error => {
            this.loading = false;
            if (error === 'Too Many Requests') {
                this.result = 0;
                this.alertService.error('Trop de requètes, réessayer dans quelques minutes.');
            } else {
                this.alertService.error('Une erreur est survenue');
            }
            console.log(error);
        });
    }

    loadResult() {
        var that = this;
        this.citiesFull.forEach(function callback(city, index) {
            if (index >= that.currentIndex && index < (that.currentIndex + 10)) {
                that.setImg(city);
            }
        });
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {

        const pos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
        const max = document.documentElement.scrollHeight - 50;

        if (pos >= max && this.loading === false && this.cities.length > this.currentIndex) {
            this.currentIndex += 10;
            this.loadResult();
        }
    }

    setImg(city: City) {
        this.http.get<any>('https://fr.wikipedia.org/w/api.php?action=query&origin=*&format=json&generator=search&gsrsearch=' + city.name + ' ' + city.zip_code + '&gsrnamespace=0&gsrlimit=1&prop=pageimages&piprop=thumbnail&pilimit=max&pithumbsize=400').subscribe(r => {
            if (Object.values(r.query.pages)[0]['thumbnail'] == undefined || Object.values(r.query.pages)[0]['thumbnail'] == '') {
                this.http.get<any>('https://fr.wikipedia.org/w/api.php?action=query&origin=*&format=json&generator=search&gsrsearch=' + city.name + '&gsrnamespace=0&gsrlimit=1&prop=pageimages&piprop=thumbnail&pilimit=max&pithumbsize=400').subscribe(r => {
                    if (Object.values(r.query.pages)[0] && Object.values(r.query.pages)[0]['thumbnail'] && Object.values(r.query.pages)[0]['thumbnail']['source']) {
                        city.image = Object.values(r.query.pages)[0]['thumbnail']['source'];
                    }
                    this.cities.push(city);
                }, error => {
                    this.cities.push(city);
                });
            } else {
                city.image = Object.values(r.query.pages)[0]['thumbnail']['source'];
                this.cities.push(city);
            }
        }, error => {
            this.cities.push(city);
        });
    }

    deleteSearch() {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Etes-vous sûr de vouloir supprimer le secteur "' + this.currentSearch.title + '"'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.click('search_city_result_search_delete_confirm', this.currentSearch.id);
                this.adService.deleteSearchCity(this.currentSearch).subscribe(r => {
                    this.alertService.success('Recherche supprimée.');
                    this.router.navigate(['/app/city']);
                    this.alertService.success('Recherche supprimée.', true);
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                });
            }
        });
    }

    editSearch() {
        const dialogRef = this.dialog.open(EditCityComponent, {
            width: '420px',
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('search_city_result_search_rename_confirm', this.currentSearch.id);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                    }
                });
            } else {
                this.trackingService.click('search_city_result_search_rename_cancel', this.currentSearch.id);
            }
        });
    }

    duplicateSearch() {
        const dialogRef = this.dialog.open(DupplicateCityComponent, {
            width: '420px',
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('search_city_result_search_duplicate_confirm', this.currentSearch.id);
                this.userSearchs.push(result.currentSearch);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                        this.params = {id: this.currentSearch.id};
                        this.location.replaceState('/app/city/' + this.currentSearch.id);
                    }
                });
            } else {
                this.trackingService.click('search_result_search_duplicate_cancel', this.currentSearch.id);
            }
        });
    }

    saveSearch() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/map-city-search.png', plan: 'Essentiel', feature: 'Recherche des villes rentables'}
            });
        } else {
            const dialogRef = this.dialog.open(SaveCityComponent, {
                width: '480px',
                data: {searchParams: this.currentSearch.search_city_params, userSearch: this.currentSearch, userSearchs: this.userSearchs},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_confirm', this.currentSearch.id);
                    this.userSearchs.push(result.currentSearch);
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;

                            var currentSearch: UserSearch = ({} as UserSearch);
                            currentSearch.search_ad_params = SEARCH_PARAMS;
                            currentSearch.search_ad_params.price = [0, 1000000];
                            currentSearch.search_ad_params.surface = [0, ];
                            currentSearch.search_ad_params.rendement = [0, 25];
                            currentSearch.search_ad_params.cities = [];
                            currentSearch.search_ad_params.search_city_params_id = this.currentSearch.id;
                            this.userService.setCurrentSearch(currentSearch);
                            this.router.navigate(['/app/search/result']);
                        }
                    });
                }
            });
        }
    }

    loadSearch(event) {
        this.params = {id: this.currentSearch.id};
        this.location.replaceState('/app/city/' + this.currentSearch.id);
        this.search();
    }

    toFloat(s) {
        return parseFloat(s);
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            data: {video: 'city_search'}
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
